import React from "react";
import { format12h } from "../utils/date";

export default function PrayerBoard({ data, title = "Prayer & Iqamah Times" }) {
  if (!data) return null;

  const rows = [
    { label: "Fajr", time: data.fajr, iqamah: data.fajrIqamah },
    { label: "Dhuhr", time: data.dhuhr, iqamah: data.dhuhrIqamah },
    { label: "Asr", time: data.asr, iqamah: data.asrIqamah },
    { label: "Maghrib", time: data.maghrib, iqamah: data.maghribIqamah },
    { label: "Isha", time: data.isha, iqamah: data.ishaIqamah },
  ];

  return (
    <div className="board">
      <h2>{title}</h2>
      <table className="table">
        <thead>
          <tr>
            <th>Prayer</th>
            <th>Prayer Time</th>
            <th>Iqamah Time</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label}>
              <td>{r.label}</td>
              <td>{format12h(r.time)}</td>
              <td>{format12h(r.iqamah)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="extras">
        <div>
          <strong>Sunrise:</strong> {format12h(data.sunrise)}
        </div>
        <div>
          <strong>Dhuha:</strong> {format12h(data.dhuha)}
        </div>
        <div>
          <strong>Jumuah:</strong> {format12h(data.jumuah)}
        </div>
        <div>
          <strong>Jumuah Iqamah:</strong> {format12h(data.jumuahIqamah)}
        </div>
      </div>
    </div>
  );
}
